<div class="col-xs-8 col-md-8 col-centered col-slider no-padding row">
  <div class="no-padding orders-forms orders-form-box">
    <users-list [actions]="actions"></users-list>
  </div>
</div>

<message-dialog></message-dialog>
<send-balance-dialog></send-balance-dialog>
